import { parseTimeToMinutes } from './time'

export interface ShiftOrderFields {
  id: string
  name: string
  startTime: string
  endTime: string
}

const timeValue = (value: string): number => parseTimeToMinutes(value) ?? Number.MAX_SAFE_INTEGER

export const compareShiftOrder = (a: ShiftOrderFields, b: ShiftOrderFields): number =>
  timeValue(a.startTime) - timeValue(b.startTime) ||
  timeValue(a.endTime) - timeValue(b.endTime) ||
  a.name.localeCompare(b.name) ||
  a.id.localeCompare(b.id)

export const sortShiftRows = <T>(
  rows: readonly T[],
  getOrderFields: (row: T) => ShiftOrderFields
): T[] => rows.toSorted((a, b) => compareShiftOrder(getOrderFields(a), getOrderFields(b)))
